export default "__VITE_PUBLIC_ASSET__6ef800ee__"